import { render, staticRenderFns } from "./LodgingAdd.vue?vue&type=template&id=56d75f55&"
import script from "./LodgingAdd.vue?vue&type=script&lang=js&"
export * from "./LodgingAdd.vue?vue&type=script&lang=js&"
import style0 from "./LodgingAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LodgingAdd.vue"
export default component.exports